module.exports = {"TXTWCL_Less_than_1X":{"id":"TXTWCL_Less_than_1X","defaultMessage":"Less than 1''"}}